import { Paper, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

export function SettingPanel({
	title,
	hint,
	children,
	prominent = false,
}: {
	title: string;
	hint: string;
	children: ReactNode;
	prominent?: boolean;
}) {
	return (
		<Paper p={prominent ? "lg" : "md"} radius="lg" withBorder h="100%">
			<Stack gap="sm">
				<Title order={prominent ? 3 : 4}>{title}</Title>
				<Text size="sm" c="dimmed">
					{hint}
				</Text>
				{children}
			</Stack>
		</Paper>
	);
}
